import { useEffect, useRef, useState } from "react";
import Fuse from "fuse.js";

const FUSE_OPTIONS = { keys: ['label', 'desc'] };

export function useFuse(searchTerm, items) {
  const fuse = useRef(null);
  const [suggestions, setSuggestions] = useState([]);
  const itemsRef = useRef(items);

  useEffect(() => {
    itemsRef.current = items;
    fuse.current = new Fuse(items, FUSE_OPTIONS);
  }, [items]);

  useEffect(() => {
    const query = searchTerm.trim();
    if (!query) {
      setSuggestions([]);
      return;
    }

    if (!fuse.current) {
      fuse.current = new Fuse(itemsRef.current, FUSE_OPTIONS);
    }

    const results = fuse.current.search(query);
    setSuggestions(results.map(({ item }) => item));
  }, [searchTerm]);

  return suggestions;
}
